module.exports = new __parcel__URL__("floor2.63abec63.jpg").toString();